import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import FileHistoryEntry from './HistoryEntry';
import ErrorBoundary from '../ErrorBoundary';
import LoadingSmall from '../LoadingSmall';

import { showModal } from '../../actions';

import { userCan } from '../../helpers/Auth';

class FileHistory extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };

    this.toggle = this.toggle.bind(this);
    this.handleOpenDiffModal = this.handleOpenDiffModal.bind(this);
  }

  toggle() {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  }

  handleOpenDiffModal(log) {
    const { dispatch } = this.props;
    dispatch(showModal('FileDiffModal', {
      className: 'modal-file-diff',
      backdrop: true,
      log,
    }));
  }

  render() {
    const {
      intl,
      file,
      logs,
      loading,
    } = this.props;

    if (!userCan('file.history', file)) {
      return null;
    }

    return (
      <div className="file-history file-details-item">
        <div className="file-detail-header">
          {intl.formatMessage({ defaultMessage: 'History' })}
        </div>
        <ErrorBoundary>
          <div className="file-detail-body">
            {loading ? (
              <LoadingSmall />
            ) : (
              <div className="users-list file-history-list">
                {logs.map(log => (
                  <FileHistoryEntry
                    key={log.id}
                    log={log}
                    handleOpenDiffModal={this.handleOpenDiffModal}
                  />
                ))}
              </div>
            )}
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}

FileHistory.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
  logs: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default injectIntl(connect()(FileHistory));
